import CommentDeleteButton from "./comment-delete-button";

export default CommentDeleteButton;